import React from "react";

import "../../../styles/About/Route/Graduation.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";

const Graduation = () => {
  return (
    <>
      <div className="graduation">
        <div className="graduation__container">
          <div className="graduation__header">
            <h2 className="graduation__number">
              0<span>4</span>
            </h2>
            <h1 data-aos="fade-down" data-aos-offset="0">
              E<span>ngineering</span>.
            </h1>
          </div>

          <div className="graduation__description">
            <h1>Netaji Subhas University Of Technology</h1>
            <h2>
              <FontAwesomeIcon
                icon={faCalendarDays}
                className="internships__calendar"
              />
              &nbsp;&nbsp;August 2021 - July 2025
            </h2>
            <p>
              Pursuing B.Tech in Electrical Engineering from Netaji Subhas
              University Of Technology. 
              From the first year, I had a great
              inclination towards technology and coding, which has been
              energized and fueled by amazing peers and discussions at this
              college.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Graduation;
